export class PointAddress {

  public country?: string;
  public city?: string;
  public house?: string;
  public postCode?: string;
  public countryCode?: string;
  public district?: string;
  public street?: string;
  public description?: string;

}
